import React, { Component } from 'react'
import { Container, Row, Col } from 'reactstrap'
import withApolloClient from '../withApolloClient'
import SubrogationClaimListHeader from './SubrogationClaimListHeader'
import SubrogationClaimList from './SubrogationClaimList'
import SubrogationClaimActions from './SubrogationClaimActions'
import { usePresetFilters } from '../Filters/presetFilters'
import './Incidents.css'

// Editable, visible default: the list opens showing archived claims; the user can
// flip it to false or drop it entirely from the Advanced Filters popover/chips.
const IS_ARCHIVED_PRESET = [
    { fieldName: "is_archived", filterType: "equal", filterValues: "true", editable: true, visible: true },
]

const tableHeaders = [
    { id: "date_added", name: "Date Added", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "claim_number", name: "Claim #", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "assignedTo", name: "Assigned To", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "payment_id", name: "Payment ID", sortable: false, preferenceSettings: { isVisible: false, canToggleVisibility: true, canReorder: true } },
    { id: "payment_date", name: "Payment Date", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "requested_amount", name: "Requested Amount", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "gross_collected", name: "Gross Collected", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "net_collected", name: "Net Collected", sortable: false, preferenceSettings: { isVisible: false, canToggleVisibility: true, canReorder: true } },
    { id: "tpa_expenses", name: "TPA Expenses", sortable: false, preferenceSettings: { isVisible: false, canToggleVisibility: true, canReorder: true } },
    { id: "incident_name", name: "Incident Name", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "incident_date", name: "Incident Date", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "party", name: "Party", sortable: false, preferenceSettings: { isVisible: false, canToggleVisibility: true, canReorder: true } },
    { id: "tpa", name: "TPA", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "status", name: "Status", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "tpa_status", name: "TPA Status", sortable: false, preferenceSettings: { isVisible: false, canToggleVisibility: true, canReorder: true } },
    { id: "filed_date", name: "Filed Date", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "acknowledgment_date", name: "Acknowledgment Date", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "incident_branch", name: "Incident Branch", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "adjuster", name: "Adjuster", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "in_litigation", name: "In Litigation", sortable: false, preferenceSettings: { isVisible: false, canToggleVisibility: true, canReorder: true } },
]
const getDefaultColumnConfig = () => tableHeaders.map((column, index) => ({ ...column, order: index }))
const DEFAULT_FILTERS = {}

class SubrogationClaimListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            orderBy: ["-date_added"],
            filterValues: { ...DEFAULT_FILTERS },
            columnConfig: getDefaultColumnConfig(),
        }
    }
    setColumnConfig = (columnConfig) => this.setState({ columnConfig })

    updateOrder = (string) => {
        let order = this.state.orderBy ? [...this.state.orderBy] : []
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState({ orderBy: order })
    }

    render() {
        return (
            <Container fluid className="bos-listing-container">
                <Row>
                    <Col xs={8}>
                        <SubrogationClaimListHeader
                            filterValues={this.state.filterValues}
                            setFilterValues={(filterValues) => this.setState({ filterValues })}
                            defaultFilters={DEFAULT_FILTERS}
                            {...this.props}
                        />
                    </Col>
                    <Col xs={4}>
                        <SubrogationClaimActions
                            columnConfig={this.state.columnConfig}
                            setColumnConfig={this.setColumnConfig}
                            tableId="subrogation_claim"
                            defaultColumnConfig={getDefaultColumnConfig()}
                            {...this.props}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm="12">
                        <SubrogationClaimList
                            columnConfig={this.state.columnConfig}
                            searchTerm={this.state.filterValues?.searchTerm || null}
                            presets={this.props.presets}
                            orderBy={this.state.orderBy}
                            updateOrder={this.updateOrder}
                        />
                    </Col>
                </Row>
            </Container>
        )
    }
}

const SubrogationClaimListContainerWithApollo = withApolloClient(SubrogationClaimListContainer)

// Preset state is owned here so both the header (popover + chips) and the list
// (query variables) share one source of truth.
export default function SubrogationClaimListContainerWithFilters(props) {
    const [presets, setPresets] = usePresetFilters(IS_ARCHIVED_PRESET)
    return <SubrogationClaimListContainerWithApollo {...props} presets={presets} setPresets={setPresets} />
}
